module.exports = __webpack_public_path__ + "static/media/screenshot8.0374ab28.png";